import { POST } from "../../index";

export const findViolationData = (param) => POST("/v1/Violation/findViolationData", param);
